<div class="dialog-box">
  <div class="text">
    <div class="title">{{ 'redirect_to_home_due_to_inactivity' | translate }}</div>
    <div class="timer" id="timer">{{ 'in_seconds' | translate: { time: time } }}</div>
  </div>
  <div class="actions">
    <button mat-raised-button class="primary-button" (click)="closeDialog()">{{ 'still_busy' | translate }}</button>
    <button mat-flat-button (click)="returnHome()">{{ 'return_home' | translate }}</button>
  </div>
</div>
